import React from 'react';
import { MonitorPlay } from 'lucide-react';
import {
  PLATFORM_REVIEWER_AUTH_URL,
  PLATFORM_REVIEWER_COMPANY_NAME,
} from '../../config/platformReviewerAccount';

/**
 * Кнопка «Демо-доступ» — открывает единый вход Маркбэйс id (UAM).
 * Учётные данные проверяющего: email + пароль (пароль только в PDF для экспертизы).
 */
export default function ReviewerDemoAccessButton({
  onClick,
  disabled = false,
  className = 'mb-login__demo-btn',
  showHint = true,
}) {
  return (
    <div className="mb-login__demo-wrap">
      <button
        type="button"
        className={className}
        onClick={onClick}
        disabled={disabled}
      >
        <MonitorPlay size={16} aria-hidden />
        Демо-доступ
      </button>
      {showHint && (
        <p className="mb-login__demo-hint">
          Вход через{' '}
          <a href={PLATFORM_REVIEWER_AUTH_URL} target="_blank" rel="noreferrer">
            {PLATFORM_REVIEWER_AUTH_URL.replace(/^https?:\/\//, '')}
          </a>
          {' '}(единый аккаунт Маркбэйс id). Компания в кабинете: «{PLATFORM_REVIEWER_COMPANY_NAME}».
          Для экспертизы Минцифры — логин и пароль из инструкции PDF.
        </p>
      )}
    </div>
  );
}
